














































import { Component, Vue, Prop } from 'vue-property-decorator'
import Avatar from '@/apps/open/components/Avatar'
import { IUser } from '@/apps/open/types'
import { getAdminList } from '@/apps/open/services/admin'
import AddAdminDialogBody from '@/apps/open/components/DialogBodys/AddAdmin.vue'
import Button from '@/apps/open/components/Button'
import { onRequestError } from '@/apps/open/utils'
import store from '@/apps/open/store'
import { getDeveloperSetting } from '@/apps/open/services/developer'

@Component({
  components: {
    Avatar,
    Button
  }
})
export default class AdminSelectorDialogBody extends Vue {
  adminLimit = 0

  @Prop({
    default: () => []
  })
  filterRoles!: number[]

  @Prop({
    default: () => []
  })
  selectedIds!: number[]

  @Prop({
    default: () => []
  })
  disabledIds!: number[]

  @Prop()
  limit?: number

  @Prop()
  onCancel!: Function

  @Prop()
  onOk!: Function

  users: IUser[] = []

  get curEnterprise () {
    return store.getters['User/curEnterprise']
  }

  get selectedList () {
    return this.users.filter((item: IUser) => item.checked && !this.isDisabled(item.id))
  }

  get disabledSubmit () {
    return this.selectedList.length === 0
  }

  get remainTotal () {
    const remain = this.adminLimit - this.users.length
    return remain < 0 ? 0 : remain
  }

  async getAdminLimit () {
    try {
      const res = await getDeveloperSetting(this.curEnterprise && this.curEnterprise.developer_id)
      this.adminLimit = res.data.object.engineer_limit
    } catch (err) {
      this.$message.error(err.message)
    }
  }

  isDisabled (id: number) {
    return this.disabledIds.includes(id)
  }

  showAddAdminDialog () {
    this.$dialog.show({
      title: '添加管理员',
      body: AddAdminDialogBody,
      bodyProps: {
        onCancel: this.$dialog.back,
        onOk: this.addAdminSuccess
      }
    })
  }

  addAdminSuccess (users: any) {
    this.$message.success('添加管理员成功')
    this.$dialog.back()
    let arr:IUser[] = []
    let uids = this.users.map(u => u.id)
    users.forEach((user:any) => {
      if (!uids.includes(user.userid)) {
        this.users.push({
          id: user.userid,
          name: user.username,
          avatar: user.avatar,
          phone: user.phone,
          email: '',
          checked: true
        })
      }
    })
  }

  remove (id: number) {
    const user = this.users.find((item: IUser) => item.id === id) as IUser
    user.checked = false
  }

  handleCheck (item: IUser, checked: boolean) {
    if (!this.limit) {
      return
    }

    if (checked && this.selectedList.length > this.limit) {
      if (this.limit === 1) {
        this.users.map((user: IUser) => {
          if (user.id !== item.id && user.checked) {
            user.checked = false
          }
        })
        return
      }
      item.checked = false
      this.$message.error(`最多不超过${this.limit}人`)
    }
  }

  async getAdminList () {
    try {
      const params = {
        developer_id: this.curEnterprise.developer_id
      }
      const res = await getAdminList(params)
      this.users = res.data.object_array
        .filter((item: any) => !this.filterRoles.includes(item.dev_role_id))
        .map((item: any) => ({
          id: item.userid,
          name: item.username,
          avatar: item.avatar,
          phone: item.phone,
          checked: this.selectedIds.includes(item.userid)
        }))
    } catch (error) {
      onRequestError(error)
    }
  }

  onSubmit () {
    this.onOk(this.selectedList)
  }

  async mounted () {
    await this.getAdminList()
    this.getAdminLimit()
  }
}
